<div class="modal1Main leaguRegPop  defaultPop">
  <div class="modalHeader"> 
    <span class="title">
      League Invitation
    </span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>

  <div class="defaultPopCont leaguinvSec">
    <div class="leaguinvImg" style='background: rgba(0, 0, 0, 0) url("http://192.168.0.149/drafters.org/s3-bucket/draftersnewproduction/assets/default/images/user.png") no-repeat scroll 0px 0px / cover;'></div>
      <p>{{parameters.body}}</p>
  </div>

  <div class="text-center defaultPopfoot">
      <button mat-raised-button color="primary" class="cancelBtn" (click)="viewSetting()">View Settings</button>
      <button mat-raised-button color="primary" class="joinDraftBtn" (click)="acceptInvitation()">Join</button> 
  </div>
</div> 
